import axios from 'axios';
import {cloneDeep} from 'lodash';

const defaultState = {
  insuranceCompanies: [],
  // insurance-company/carriers: the carriers a record can be tied to. Fixed for
  // the session, so fetched once.
  carrierCatalog: [],
  carrierCatalogLoaded: false,
};
// The catalog call in flight, shared by the screens that ask at the same time.
let carrierCatalogRequest = null;
const state = {
  ...cloneDeep(defaultState),
};

const getters = {
  insuranceCompanies: () => state.insuranceCompanies,
  carrierCatalog: () => state.carrierCatalog,
};
const actions = {
  /** The carrier catalog, fetched once per session unless `force`d. */
  fetchCarrierCatalog({ commit, state }, force) {
    if (state.carrierCatalogLoaded && !force) return Promise.resolve(state.carrierCatalog);
    if (carrierCatalogRequest && !force) return carrierCatalogRequest;
    const request = axios.post('/insurance/insurance-company/carriers', {})
      .then((response) => {
        commit('SET_CARRIER_CATALOG', (response.data && response.data.carriers) || []);
        return state.carrierCatalog;
      })
      .catch((error) => {
        console.error('Error fetching carrier catalog:', error);
        return state.carrierCatalog;
      })
      .finally(() => {
        if (carrierCatalogRequest === request) carrierCatalogRequest = null;
      });
    carrierCatalogRequest = request;
    return request;
  },
  getInsuranceCompany({
    commit,
    state
  }, insuranceCompanyId) {
    return axios.post('/insurance/insurance-company/detail', {
      insuranceCompanyId,
    })
      .then((response) => response.data)
      .catch((error) => {
        console.error('Error fetching policies:', error);
      });
  },
  saveInsuranceCompany({
    commit,
    state
  }, data) {
    return axios.post('/insurance/insurance-company/save', {
      ...data,
    })
      .then((response) => response.data)
      .catch((error) => {
        console.error('Error fetching policies:', error);
      });
  },
};

const mutations = {
  SET_CARRIER_CATALOG(state, carriers) {
    state.carrierCatalog = carriers;
    state.carrierCatalogLoaded = true;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
